<template>
  <modal
    :show="show"
    @close="close()"
  >
    <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
      <button
        type="button"
        class="bg-white rounded-md text-font hover:text-font-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
        @click="close"
      >
        <span class="sr-only">Close</span>
        <!-- Heroicon name: outline/x -->
        <svg
          class="h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
    <div class="m-5">
      <div class="mb-5">
        <h1 class="text-xl font-bold">
          Terms and Conditions
        </h1>
        <h4 class="text-s mt-3 font-semibold">
          {{ accountType.title }}
        </h4>
        <p class="text-xs">
          {{ accountType.description }}
        </p>
      </div>
      <p>
        {{ accountType.terms }}
      </p>
    </div>
    <div class="m-5">
      <button
        class="bg-gray-300 m-2 w-1/5 py-2 rounded-lg"
        @click="close()"
      >
        Close
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '../../Jetstream/Modal.vue';

export default {
  name: 'TermsAndConditions',
  components: {
    Modal,
  },
  props: ['accountType'],
  emits: ['close'],
  data() {
    return {
      form: this.$inertia.form({
        accountType: this.accountType,
      }),
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped></style>
